import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StaffStateService<T = any> {
  selectedStaffForm$ = new BehaviorSubject<T | null>(null);

  setSelected(form: T | null): void {
    this.selectedStaffForm$.next(form);
  }

  clear(): void {
    this.selectedStaffForm$.next(null);
  }
}


